/**
 * GUARDA-ROUPA (10.4Z): escolhe/compra ROUPAS (cosmético) do Hunter com Fragmentos.
 * UI pura; o Game aplica a troca (Player.applyOutfit) e a compra (spendCoins). "void" é grátis.
 *
 * 10.9HB — REFEITO: prévia 3D grande no topo (o Caçador real), GRADE de cards com a paleta de cada
 * roupa (armadura / capa / energia / cristal), toque no card = EXPERIMENTA a roupa na prévia antes
 * de comprar (o Game aplica a paleta sem salvar; fechar devolve a roupa de verdade), e uma faixa de
 * detalhe com nome, descrição e o botão Vestir / Comprar / Equipado.
 */
import { PreviewRotor } from "./PreviewRotor";
import { GameConfig } from "../config/GameConfig";
import { confirmBuy } from "./ConfirmBuy"; // 10.9ET
import { i18n } from "../i18n/i18n";
import type { GameProgress } from "../progression/GameProgress";

export interface WardrobeHandlers {
  onClose: () => void;
  onChoose: (id: string) => void; // possui → equipa; não possui → tenta comprar
  /** 10.9HB — experimentar: aplica a paleta no Caçador SEM salvar (null = volta pra roupa escolhida) */
  onPreview: (id: string | null) => void;
}

function hex(n: number): string {
  return "#" + n.toString(16).padStart(6, "0");
}

export class WardrobeScreen {
  private readonly root: HTMLDivElement;
  private readonly titleEl: HTMLElement;
  private readonly coinsEl: HTMLElement;
  private readonly gridEl: HTMLElement;
  private readonly detailEl: HTMLElement;
  private readonly closeBtn: HTMLButtonElement;
  private progress: GameProgress | null = null;
  private selected = "void"; // card em foco (experimentando)

  constructor(uiRoot: HTMLElement, private readonly h: WardrobeHandlers) {
    this.root = document.createElement("div");
    this.root.className = "overlay wardrobe-overlay";
    this.root.hidden = true;
    this.root.innerHTML = `
      <div class="panel shop-panel wd-panel">
        <div class="shop-head">
          <h2 class="shop-title"></h2>
          <div class="shop-head-r"><div class="shop-coins">🪙 <b class="shop-coins-n">0</b></div>
            <button class="scr-x" data-a="close" aria-label="${i18n.t("common.close")}">✕</button></div>
        </div>
        <div class="wd-live"><canvas class="wd-3d pd-3d" width="240" height="300" aria-label="preview"></canvas>
          <div class="wd-detail"></div></div>
        <div class="wd-grid"></div>
        <div class="menu-btns"><button class="btn primary" data-a="close"></button></div>
      </div>`;
    uiRoot.appendChild(this.root);
    this.rotor.bind(this.root.querySelector<HTMLCanvasElement>(".wd-3d")!); // 10.9GZ
    this.titleEl = this.root.querySelector(".shop-title")!;
    this.coinsEl = this.root.querySelector(".shop-coins-n")!;
    this.gridEl = this.root.querySelector(".wd-grid")!;
    this.detailEl = this.root.querySelector(".wd-detail")!;
    this.closeBtn = this.root.querySelector('.menu-btns [data-a="close"]')!;
    this.root.querySelectorAll<HTMLButtonElement>('[data-a="close"]').forEach((button) => { button.onclick = () => this.h.onClose(); });

    for (const o of GameConfig.outfits) {
      const card = document.createElement("button");
      card.className = "wd-card";
      card.dataset.id = o.id;
      const p = o.palette;
      card.innerHTML = `
        <span class="wd-chips">
          <i class="wd-chip" style="background:${hex(p.armor)}" title="armor"></i>
          <i class="wd-chip" style="background:${hex(p.cloak)}" title="cloak"></i>
          <i class="wd-chip glow" style="background:${hex(p.accent)};box-shadow:0 0 8px ${hex(p.accentEmissive)}" title="accent"></i>
          <i class="wd-chip glow" style="background:${hex(p.crystal)};box-shadow:0 0 8px ${hex(p.crystalEmissive)}" title="crystal"></i>
        </span>
        <span class="wd-name"></span>
        <span class="wd-state"></span>`;
      card.onclick = () => { this.selected = o.id; this.h.onPreview(o.id); this.render(); };
      this.gridEl.appendChild(card);
    }
    i18n.onChange(() => this.render());
  }

  // 10.9GZ — prévia 3D ao vivo: trocar/experimentar roupa já aparece no Caçador aqui
  private readonly rotor = new PreviewRotor();
  get isOpen(): boolean { return !this.root.hidden; }
  get previewCanvas(): HTMLCanvasElement | null { return this.root.querySelector<HTMLCanvasElement>(".wd-3d"); }
  tickPreview(dt: number): number { return this.rotor.tick(dt); }

  open(p: GameProgress): void {
    this.progress = p;
    this.selected = p.outfit;
    this.render();
    this.root.hidden = false;
  }
  hide(): void {
    this.root.hidden = true;
    this.h.onPreview(null); // 10.9HB — devolve a roupa de verdade
  }

  refresh(p: GameProgress): void {
    this.progress = p;
    this.selected = p.outfit;
    this.render();
  }

  private render(): void {
    const p = this.progress;
    this.titleEl.textContent = i18n.t("wardrobe.title");
    this.closeBtn.textContent = i18n.t("menu.back");
    if (!p) return;
    this.coinsEl.textContent = String(p.coins);
    for (const o of GameConfig.outfits) {
      const card = this.gridEl.querySelector<HTMLElement>(`.wd-card[data-id="${o.id}"]`)!;
      const owned = p.ownsOutfit(o.id);
      const wearing = p.outfit === o.id;
      card.classList.toggle("sel", this.selected === o.id);
      card.classList.toggle("wearing", wearing);
      card.classList.toggle("owned", owned);
      const exclusive = !!(o as { exclusive?: boolean }).exclusive;
      card.querySelector(".wd-name")!.textContent = i18n.t(`outfit.${o.id}.name`);
      // 10.9J6 — roupa EXCLUSIVA (só Loja VIP) não é "grátis": mostra cadeado, não 🎁, senão o
      // jogador achava que bastava tocar pra ganhar (era exatamente o bug: price:0 = "🎁").
      card.querySelector(".wd-state")!.textContent = wearing ? "✓" : owned ? "" : exclusive ? "🔒" : o.price > 0 ? `🪙 ${o.price}` : "🎁";
    }
    // faixa de detalhe: nome + descrição + ação da roupa em foco
    const o = GameConfig.outfits.find((x) => x.id === this.selected) ?? GameConfig.outfits[0];
    const owned = p.ownsOutfit(o.id);
    const wearing = p.outfit === o.id;
    const exclusive = !!(o as { exclusive?: boolean }).exclusive;
    const lockKey = (o as { lockKey?: string }).lockKey ?? "wardrobe.exclusive"; // 10.9K3 — roupa do passe tem aviso próprio
    const canPay = p.coins >= o.price;
    const locked = !owned && (exclusive || !canPay);
    const label = wearing ? i18n.t("wardrobe.equipped") : owned ? i18n.t("wardrobe.equip") : exclusive ? i18n.t(lockKey) : `${i18n.t("wardrobe.buy")} · 🪙 ${o.price}`;
    this.detailEl.innerHTML = `
      <div class="wd-dname">${i18n.t(`outfit.${o.id}.name`)}</div>
      <div class="wd-ddesc">${i18n.t(`outfit.${o.id}.desc`)}</div>
      <div class="wd-dhint">${i18n.t("wardrobe.live")}</div>
      <button class="btn shop-buy wd-act${wearing ? " primary" : ""}${locked ? " locked" : ""}" ${wearing || locked ? "disabled" : ""}>${label}</button>`;
    const btn = this.detailEl.querySelector<HTMLButtonElement>(".wd-act")!;
    btn.onclick = () => {
      if (owned) { this.h.onChoose(o.id); return; }
      if (exclusive) return; // botão já vem desabilitado; sem confirmação de compra pra algo que não se compra aqui
      confirmBuy(this.root, i18n.t("shop.confirmBuy", { name: i18n.t(`outfit.${o.id}.name`), price: `🪙 ${o.price}` }), () => this.h.onChoose(o.id));
    };
  }
}
